<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        lg="6"
        md="6"
        sm="12"
        v-for="(item, index) in reportDatas"
        :key="index"
      >
        <v-card
          class="mx-auto FileLists"
          style="border-radius: 20px !important; background: #fff"
        >
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text-h6 mb-1">
                <v-row>
                  <v-col
                    lg="6"
                    md="6"
                    sm="12"
                    class="jumbo fontcolor"
                    @click="$router.push(`/product/${item.id}`)"
                  >
                    <CopyTableCell :text="item.name"></CopyTableCell>
                  </v-col>
                  <v-col sm="6" md="6" lg="4">
                    <v-select
                      v-if="item.units && rowvisble"
                      :value="item.convertunit"
                      :items="item.units"
                      hide-details="auto"
                      item-text="name"
                      style="width: 170px"
                      item-value="id"
                      label="Units"
                      outlined
                      dense
                      :error-messages="errors"
                    >
                      <template v-slot:item="{ item, attrs, on }">
                        <v-list-item
                          v-bind="attrs"
                          v-on="on"
                          @click="updateUnitPrice($event, index, item)"
                        >
                          <v-list-item-title
                            :id="attrs['aria-labelledby']"
                            v-text="item.name"
                          ></v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col lg="1" md="1" sm="3">
                    <v-menu
                      transition="slide-y-transition"
                      bottom
                      :nudge-width="25"
                      content-class="my-menu"
                      :close-on-content-click="false"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-ship class="ma-8" x-large>
                          <v-icon
                            color="orange darken-2"
                            dark
                            style="font-size: 25px !important"
                            v-on="on"
                          >
                            mdi-cash-check
                          </v-icon>
                        </v-ship>
                      </template>
                      <v-card>
                        <v-row>
                          <v-col>
                            <h4>
                              Purchased Price :- LKR
                              {{ item.purchase_price | formatCurrency }}
                            </h4>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col>
                            <h4>
                              Minimum Price :- LKR
                              {{ item.min_price | formatCurrency }}
                            </h4>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-list-item-title>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="6"
                  class="subtextalign mt-0"
                >
                  Brand : {{ item.brand }}
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="6"
                  class="subtextalign mt-0"
                >
                  Category : {{ item.category }}
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="6"
                  class="subtextalign mt-0"
                >
                  Batch : {{ item.batch ? item.batch.batch : '...' }}
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="6"
                  class="subtextalign mt-0"
                >
                  Quantity : {{ item.quantity }}
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="6"
                  class="subtextalign mt-0"
                >
                  Unit : {{ item.unit ? item.unit.name : '...' }}
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="6"
                  class="subtextalign mt-0"
                >
                  Sale Price :LKR {{ item.selling_price | formatCurrency }}
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    reportDatas: {
      type: Array,
      default: [],
    },
    rowvisble: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    updateUnitPrice(event, index, item) {
      this.$emit('updateUnitPrice', event, index, item);
    },
  },
};
</script>
<style scoped>
.theme--light.v-list-item .v-list-item__subtitle {
  color: #282828;
}
.FileLists {
  align-items: stretch;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}
.jumbo:hover {
  color: #740c0c;
  transition: 0.5s;
  cursor: pointer;
}
.fontcolor {
  font-family:
    BlinkMacSystemFont,
    -apple-system,
    Segoe UI,
    Roboto,
    Helvetica,
    Arial,
    sans-serif;
  color: #20289e;
  font-size: 14px;
  line-height: 18px;
  font-weight: 700;
}
.subtextalign {
  font-family:
    BlinkMacSystemFont,
    -apple-system,
    Segoe UI,
    Roboto,
    Helvetica,
    Arial,
    sans-serif;
  font-size: 12px;
  line-height: 10px;
  font-weight: bold;
  padding-top: 0px;
}
</style>
